module.exports = __webpack_public_path__ + "static/media/135_ExteriorEntry2.bc78c075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_ExteriorEntry2.jpg
// module id = 529
// module chunks = 0